import { Link, Outlet, createFileRoute } from "@tanstack/react-router";
import { AdminRoute } from "@/components/auth/AdminRoute";
import { Button } from "@/components/ui/button";
import {
  ArrowLeft,
  ChartLine,
  Flag,
  Globe,
  ShieldCheckIcon,
  Users,
} from "lucide-react";

export const Route = createFileRoute("/admin")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminRoute>
      <AdminLayout />
    </AdminRoute>
  );
}

const navItems = [
  { to: "/admin", label: "overview", icon: ChartLine, exact: true },
  { to: "/admin/users", label: "users", icon: Users },
  { to: "/admin/sites", label: "sites", icon: Globe },
  { to: "/admin/reports", label: "reports", icon: Flag },
] as const;

function AdminLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 p-4">
      <div className="max-w-6xl mx-auto space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <ShieldCheckIcon className="h-8 w-8 text-amber-600" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900">admin</h1>
              <p className="text-gray-600 mt-0.5">site administration</p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="gap-2 rounded-2xl"
            onClick={() => (window.location.href = "/dashboard")}
          >
            <ArrowLeft className="h-4 w-4" />
            back to dashboard
          </Button>
        </div>

        <nav className="flex flex-wrap items-center gap-2">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeOptions={{ exact: !!(item as any).exact }}
              className="flex items-center gap-2 rounded-2xl border px-4 py-2 text-sm font-medium transition-colors"
              inactiveProps={{
                className:
                  "border-amber-200/50 bg-white/50 text-gray-700 hover:bg-amber-100",
              }}
              activeProps={{
                className:
                  "border-amber-300 bg-amber-500 text-white shadow-sm hover:bg-amber-600",
              }}
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </Link>
          ))}
        </nav>

        <Outlet />
      </div>
    </div>
  );
}
